module.exports = __webpack_public_path__ + "img/MGH-Nakasu-7.96d6cb3f.jpg";